import { VideoPlayer } from '../../classes/video-player';

export class YoutubePlayer extends VideoPlayer {
    constructor(options) {
        super(options);

        this.bindAll(['setVideo', 'toggleVideo']);

        this.autoplay = this.el.dataset.autoplay;

        if(!document.getElementById('youtube-player-script')){
            // Load the Youtube iframe API
            let tag = document.createElement('script');
            tag.src = "https://www.youtube.com/iframe_api";
            let scriptTag = document.getElementsByTagName('script')[0];
            scriptTag.parentNode.insertBefore(tag, scriptTag);
        }
    }

    addEvents() {
        super.addEvents();
        document.addEventListener('youtubeVideoReady', this.setVideo);
    }

    removeEvents() {
        super.removeEvents();
        document.removeEventListener('youtubeVideoReady', this.setVideo);
    }

    /**
     * Start video player and hide the poster
     */

    playVideo() {
        super.playVideo();

        if (this.videoPlayer) {
            this.isPlaying = true;
            this.videoPlayer.playVideo();
            if(!this.autoplay){
                this.dispatchVideoPlaying();
            }

        }
    }

    /**
     * Stop video player and show the poster
     */
    stopVideo() {
        super.stopVideo();
        if (this.videoPlayer) {
            this.isPlaying = false;
            this.videoPlayer.stopVideo();
        }
    }

    /**
     * Pause video player and show the poster when another video starts
     */
    pauseVideo(e) {
        super.pauseVideo();
        if (this.videoPlayer) {
            if (this.isPlaying) {
                this.isPlaying = false;
                this.videoPlayer.pauseVideo();
            }
        }
    }

    /**
     * Prepare YouTube video player
     */
    setVideo() {
        let host = 'https://www.youtube.com';

        let videoID = this.el.getAttribute('data-video-id');
        if (videoID && typeof YT !== 'undefined') {
            this.videoPlayer = new YT.Player(this.el.querySelector('.video-player'), {
                height: 'auto',
                width: '100%',
                videoId: videoID,
                playerVars: {
                    'autoplay': this.el.dataset.autoplay,
                    'controls': this.el.dataset.autoplay ? 0 : 1,
                    'mute': this.el.dataset.autoplay,
                    'loop': this.el.dataset.autoplay,
                    'rel': 0,
                    'showinfo': this.el.dataset.autoplay ? 0 : 1,
                    'modestbranding': this.el.dataset.autoplay,
                },
                host: host,
                events: {
                    onReady: () => this.onVideoPlayerReady(),
                    onStateChange: (event) => {
                        // this event calls our play/pause if user use built-in player controls
                        switch (event.data) {
                            case YT.PlayerState.PLAYING:
                                this.playVideo();
                                break;
                            case YT.PlayerState.PAUSED:
                                this.pauseVideo();
                                break;
                            case YT.PlayerState.ENDED:
                                if(this.autoplay){
                                    this.playVideo();
                                }
                                break;
                        }
                    },
                },
            });
        }
    }
}

window.onYouTubeIframeAPIReady = function() {
    document.dispatchEvent(new Event('youtubeVideoReady'));
}

Me.views['YoutubePlayer'] = YoutubePlayer;
